import React from "react";
import { makeStyles } from "@mui/styles";
import { Typography } from "../components/Typography";
import { HeaderMenu } from "../components/Header";
import { MobileWeb } from "../components/mobile/BreakPoint";
import { Theme } from "@mui/material";
import img_intro from "../asset/img_intro.png";
import { Footer } from "../components/Footer";
import { MobileFooter } from "../components/mobile/MobileFooter";
import halfCircleBlue from "../asset/half_circle_blue.png";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: "100%",
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    margin: "20px auto",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      maxWidth: 824,
      width: "100%",
      margin: "0px",
      height: "auto",
    },
  },
  body: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    alignSelf: "center",
    height: "100%",
    minHeight: 800,
    justifyContent: "center",
    borderTop: "1px solid #0000003b",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      maxHeight: 1390,
      width: "auto",
      margin: "30px 20px",
      borderTop: "none",
    },
  },
  topTextBox: {
    display: "flex",
    alignSelf: "center",
    flexDirection: "column",
    position: "relative",
    marginBottom: 20,
    right: 210,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      right: 0,
      width: "100%",
    },
  },
  top_text: {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    color: "#204FA1",
    maxWidth: 1290,
    fontSize: 18,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      fontSize: 18,
      width: "100%",
      justifyContent: "flex-start",
      marginLeft: 30,
    },
  },
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    background: "#fdf5fd",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      height: 200,
      justifyContent: "center",
    },
  },
  img: {
    width: 628,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      maxWidth: 824,
      width: "100%",
    },
  },

  middleTextBox: {
    display: "flex",
    alignSelf: "center",
    marginBottom: 20,
  },
  textBox: {
    width: "628px",
    marginBottom: "10px",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      maxWidth: 824,
      width: "100%",
      marginBottom: 20,
      textAlign: "justify",
      wordBreak: "break-all",
    },
  },
  textContainer: {
    margin: "0px 0px",
    display: "grid",
    wordBreak: "break-word",
    textAlign: "justify",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      maxWidth: 824,
      display: "grid",
    },
  },
  halfCircleBlue: {
    position: "relative",
    bottom: 5,
    right: 30,
    width: 65,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      right: 0,
      bottom: 5,
    },
  },
}));

export const SimIntroPage = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <HeaderMenu />
      <div className={classes.body}>
        <div className={classes.topTextBox}>
          <img
            src={halfCircleBlue}
            alt="blueHalfCircle"
            className={classes.halfCircleBlue}
          />
          <Typography variant="H3" className={classes.top_text}>
            심브릿지 시뮬레이션 소개
          </Typography>
        </div>

        <div className={classes.middleTextBox}>
          <div className={classes.textContainer}>
            <Typography variant="Content1" className={classes.textBox}>
              Sim Bridge는 ㈜Human Bridge에서 개발한 간호학과 학생 임상실습
              지원용 온라인 시뮬레이션 프로그램으로 2020년 한국보건산업진흥원의
              예비창업패키지 사업의 지원을 받아 개발된 프로그램입니다.
            </Typography>
            <Typography variant="Content1" className={classes.textBox}>
              현재 정신간호실습 모듈과 간호관리실습 모듈이 개발되어 있으며
              2020년에 특허출원(제10-2020-01187761)을 하였고, 2021년에는
              간호관리학과 정신간호학 외 아동간호 그리고 지역사회간호 실습
              모듈의 추가 개발을 추진중에 있습니다.
            </Typography>
            <Typography variant="Content1" className={classes.textBox}>
              현직 간호학과 교수가 개발자로 직접 참여한 만큼 간호학과 학생
              실습에 실효적인 시뮬레이션이 될 수 있도록 다년간의 축적된 경험을
              바탕으로 사례를 구성하였으며, 무엇보다도 한국간호교육평가원의
              평가인증기준에 부합하도록 모든 학습 콘텐츠와 평가원에서 제시한
              표준 학습성과를 매핑하고 이에 대한 학생별 개별 학습 성취도를 결과
              보고서(CQI 작성용)로 분석, 생성하여 교수자가 활용할 수 있도록 하여
              교수자 이용 편의를 극대화하였습니다.
            </Typography>
            <Typography variant="Content1" className={classes.textBox}>
              앞으로 저희 Sim Bridge가 간호실습교육 시뮬레이션의 대표 브랜드로
              성장할 수 있도록 많은 지원과 관심을 부탁드립니다.
              <br />
              <br />
              감사합니다.
            </Typography>
          </div>
        </div>
        <div className={classes.container}>
          <img src={img_intro} alt="intro img" className={classes.img} />
        </div>
      </div>
      <div style={{ position: "relative", alignSelf: "center" }}>
        <Footer />
      </div>
      <div style={{ display: "flex" }}>
        <MobileFooter />
      </div>
    </div>
  );
};
